import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { Redux } from '../..'
import { GygQueryOptions } from '@/src/views/components/master-pricing-list/types'
import { GygTransformationTemplate } from '@/src/types/apps/gygTransformationTemplates'

interface TransformationTemplateInitialState {
  transformationTemplates?: GygTransformationTemplate[] | null
  loading: boolean
  success: string | null
  error: string | null
}

const initialState: TransformationTemplateInitialState = {
  transformationTemplates: [],
  loading: false,
  success: null,
  error: null
}

interface TransformationTemplatesResponse {
  data: GygTransformationTemplate[]
}

export const getTransformationTemplates = createAsyncThunk<TransformationTemplatesResponse, GygQueryOptions, Redux>(
  'gygTransformationTemplates/getAllTransformationTemplates',
  async (gygQueryOptions, { extra }) => {
    const { data: responseData } = await extra.httpClient.get(`menu-transformation-templates`, {
      params: gygQueryOptions
    })

    return responseData
  }
)

const gygTransformationTemplateSlice = createSlice({
  name: 'getAllTransformationTemplates',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getTransformationTemplates.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getTransformationTemplates.fulfilled, (state, action) => {
        state.loading = false
        state.success = null
        state.transformationTemplates = action.payload.data
      })
      .addCase(getTransformationTemplates.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message ?? 'Failed to fetch menu templates'
      })
  }
})

export default gygTransformationTemplateSlice.reducer
